<template> 
  <v-card
    class="mx-auto"
    elevation="16"
    max-width="100hv"
  >
    <v-card-item />
    <v-card-text>
      <div class="home-content">
        <v-row class="text-center">
          <v-col cols="12" md="12">
            <h1 style="color: black;">¡Hola!</h1>
            <p class="p-big">Selecciona el sitio que deseas editar para comenzar.</p>
          </v-col>
        </v-row>

        <v-row class="text-center" style="max-width: 700px; margin: 0 auto;">
          <v-col cols="12" md="4" >
            <div class="card-content">
              <img src="@/assets/fronteracopper.png" alt="Frontera" style="max-width: 120px; height: 40px;">
            </div>
            <div>
              <v-row  no-gutters>
                <v-col cols="12" md="6">
                <button class="btn-red" @click="changeLanguageAndRedirect('secciones', 'frontera', 'es')">español</button>
              </v-col>
              <v-col cols="12" md="6">
                <button class="btn-red" @click="changeLanguageAndRedirect('secciones', 'frontera', 'en')">inglés</button>
              </v-col>
            </v-row>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="card-content">
              <img src="@/assets/cobredelmayo-color.png" alt="Cobre" style="max-width: 100px; height: 40px;">
            </div>
            <div>
              <v-row  no-gutters>
                <v-col cols="12" md="6">
                  <button class="btn-red" @click="changeLanguageAndRedirect('secciones', 'cobre', 'en')">inglés</button>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="card-content">
             <p>Contenido para inversionistas</p>
            </div>
            <div>
              <v-row  no-gutters>
                <v-col cols="12" md="6">
                  <button class="btn-red" @click="changeLanguageAndRedirect('documentos', 'cobre', null)">Documentos</button>
                </v-col>
                <v-col cols="12" md="6">
                 <button class="btn-red" @click="changeLanguageAndRedirect('noticias', 'cobre', null)">Noticias</button>
                </v-col>
              </v-row>   
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue';
import router from "@/router";
import { showErrorToast } from '@/kernel/alerts';
import { setLanguageForUpdateContent } from '@/kernel/utils';

export default defineComponent ({
  name: 'HomeStart',
  setup() {

    const changeLanguageAndRedirect = async (page, zone, language) => {
      if (language !== null){
        await onlyLanguage(language);
      }

      let value = '';
      switch (page) {
        case 'secciones':
          value = 'list-sections';
          break;
        case 'noticias':
          value = 'list-news';
          break;
        case 'documentos':
          value = 'list-files';
          break;
      
        default:
          showErrorToast('Página no encontrada');
          return;
      }

      await router.push({ name: value, query: { zone: zone } });
    };

    const onlyLanguage = (language) => {
      try {
        const lang = language === 'es' ? 'ES' : 'EN';
        setLanguageForUpdateContent(lang);
      } catch (error) {
        showErrorToast('Error al cambiar el idioma');
      }
      
    };
    return {
      changeLanguageAndRedirect,
      onlyLanguage
    };
  }
});
</script>

<style scoped> 
.content {
    width: 100%;
    overflow: auto;
    height: 100vh;
}
h1 {
  color: black;
} 

.mx-auto {
  max-width: 100%;
  background-color: #f5f5f5;
  height: 100vh;
  overflow: auto;
}
.home-content {
  padding: 16px;
}

.card-content {
  background-color: #ffffff;
  border-radius: 8px;
  height: 20vh;
  display: flex; 
  flex-flow: column wrap;
  justify-content:center;
  align-items: center;
}

.btn-red {
  width: 95%;
  margin-top: 0.5rem;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 4px;
  padding-bottom: 4px;
  text-transform: lowercase;
  letter-spacing: 0px;
  border-radius: 8px;;
  box-shadow: none;
}
</style>
